<style lang="less" scoped>
.container-div {}

.title-div {
  font-weight: 600;
  margin: 20px 0 10px;
  font-size: 26px;
  // flex-grow: 1;
  color: #000;
}

.history {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #4182EB;
  line-height: 20px;
  height: 25px;
  margin-top: 35px;
  margin-left: 15px;
}

.custInfo_container {
  width: 100%;
  margin: 20px 10px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  display: flex;

  .cust-item {
    width: 25%;
  }
}

.el-col {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin: 10px 0;

  >div:first-of-type {
    // width: 120px;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
  }

  >div:last-of-type {
    font-size: 14px;
    min-width: 160px;
    text-align: right;
  }

}

.cust-detail-title {
  // text-align: ;
  // margin-right: 50px;
  // width: 150px;
}

// .cust-detail-item {
//   // t-w
// }
.page-action-btns {
  margin-bottom: 10px;
}

.cust-mes {
  margin: 0px 0px 14px 18px;
}

.top-title-div {
  font-size: 15px;
  margin-left: 10px;
}

.red-tip {
  color: #f56c6c;
  font-size: 12px;
  margin-left: 100px;
}

.detail-btn {
  height: 32px;
  margin-left: 45px;
  margin-top: 10px;
}

.account_item {
  width: 237px;
  height: 101px;
  background: #4182EB;
  border-radius: 22px;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  margin-right: 50px;

  .img_con {
    width: 61px;
    height: 61px;
    background: #FFFFFF;
    border-radius: 50%;
    line-height: 75px;
    text-align: center;
  }

  .amount_con {
    flex-grow: 1;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: right;

  }

  .amount_con :last-child {
    font-size: 26px;
    font-weight: 500;
  }
}
</style>

<template>
  <div class="detail-content-div">
    <div class="title-div">账户信息</div>
    <div class="flex">
      <div class="account_item">
        <div class="img_con">
          <img src="../../assets/detail/consumption.png" alt="">
        </div>
        <div class="amount_con">
          <p>累计消费(元)</p>
          <p>{{ totalCost.totalPaid }}</p>
        </div>
      </div>
      <div class="account_item">
        <div class="img_con">
          <img src="../../assets/detail/income.png" alt="">
        </div>
        <div class="amount_con">
          <p>累计收益(元)</p>
          <p>{{ totalCost.totalAmount }}</p>
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="title-div">订单信息</div>
      <el-dropdown @command="handleCommand" trigger="click" class="history">
        <span class="el-dropdown-link">
          {{ tabValue }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown" style="max-height:200px;overflow:hidden;overflow-y: scroll;">
          <el-dropdown-item command="购买订单">购买订单</el-dropdown-item>
          <el-dropdown-item command="收益订单">收益订单</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-table v-if="tabValue == '购买订单'" class="el-table" :data="tableData" max-height="500" border min-height="200px"
      style="width: 100%;margin:20px auto" :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
      <el-table-column prop="walletListNo" width="240" label="购买订单编号">
      </el-table-column>
      <el-table-column prop="mobile" width="120" label="用户手机号">
      </el-table-column>
      <el-table-column prop="transactionStatusName" width="120" label="支付状态">
      </el-table-column>
      <el-table-column prop="pileUseServiceName" width="220" label="购买类型">
      </el-table-column>
      <el-table-column prop="packagName" width="220" label="购买名称">
      </el-table-column>
      <el-table-column prop="equityContent" width="220" label="购买内容">
      </el-table-column>
      <el-table-column prop="actInExpAmount" label="购买金额（元）">
      </el-table-column>
      <el-table-column prop="transactionCreateTime" width="220" label="购买时间">
      </el-table-column>
      <el-table-column prop="transactionChannelName" width="220" label="支付方式">
      </el-table-column>
      <el-table-column prop="walletNo" width="180" label="交易流水号">
      </el-table-column>
      <el-table-column prop="refundId" width="180" label="退款流水号">
      </el-table-column>
    </el-table>
    <el-table v-else class="el-table" :data="tableData" border style="width: 100%;margin:20px auto"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
      <el-table-column prop="orderNo" width="200" label="共享订单编号">
      </el-table-column>
      <el-table-column prop="pileCode" width="150" label="充电桩IMEI号">
      </el-table-column>
      <el-table-column prop="custPhone" width="150" label="用户手机号">
      </el-table-column>
      <el-table-column prop="actPayFee" label="电费收益（元）">
      </el-table-column>
      <el-table-column prop="payStatusName" label="订单状态">
      </el-table-column>
      <el-table-column prop="payWhen" width="160" label="用户支付时间">
      </el-table-column>
      <el-table-column prop="verifyWhen" width="160" label="桩主确认时间">
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="list-pagination">
      <ZD-pagination :pagination="pagination" v-on:pageUpdate="pageUpdate"></ZD-pagination>
    </div>
    <div class="flex-r-end">
      <button class="common-empty-button" @click="back()">返 回</button>
    </div>
  </div>
</template>

<script>
// import pageConfig from './page-config'
export default {
  data() {
    return {
      // pageConfig: pageConfig, // 页面配置
      tableData: [], // 表格数据
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
      },
      editFlag: false,
      pageTitle: '客户详情',
      tabValue: '购买订单',
      // 默认值设置
      costAndincomeDetail: {},
      detailForm: {
        payList: []
      },
      totalCost: {},
      custDto: {}, //未使用
      queryInfo: {}, // 默认内容
    }
  },
  methods: {
    init() {
      if (this.$store.state.custObj) {
        this.custInfo = this.$store.state.custObj;
        this.getTotal()
        this.getFormInfo(this.pagination, true)
      }
    },
    //获取总金额
    getTotal() {
      let _ = this
      _.$H.post(_, _.$A.cust.getTotal, { mobile: _.custInfo.mobile }).then((res) => {
        _.totalCost = res.data.data
      })
    },
    // 获取表单信息
    getFormInfo(pagination, reload = false) {
      let _ = this
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.mobile = _.custInfo.mobile;
      _.$H.post(_, _.$A.cust.pileUseWalletListWebList, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content
        _.pagination.total = res.data.data.totalElements || 0;
      })
    },
    // 获取表格数据
    // getListData(pagination, reload = false) {
    //   let _ = this
    //   _.tableData = []
    //   _.$U.showLoading(_)
    //   _.$H.get(_, _.$A.cust.custwalletlist, { mobile: _.custInfo.mobile}).then((res) => {
    //     _.tableData = res.data.data || []
    //     _.$U.hideLoading(_)
    //   })
    // },
    // 获取用户收益订单列表
    getData(pagination, reload = false) {
      let _ = this
      _.tableData = []
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        this.pagination.current = 1;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.mobile = _.custInfo.mobile;
      _.$H.post(_, _.$A.cust.getPileOrderList, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_)
      })
    },
    handleCommand(command) {
      this.pagination.pageSize = 10
      this.tabValue = command
      if (command == '收益订单') {
        this.getData(this.pagination, true)
      } else if (command == '购买订单') {
        this.getFormInfo(this.pagination, true)
      }
    },
    pageUpdate() {
      const handlers = {
        '收益订单': this.getData,
        '购买订单': this.getFormInfo
      }
      handlers[this.tabValue]?.(this.pagination, false)
    },
    back() {
      this.$router.push({
        name: "custList"
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
